import React from 'react';

export const GridControls: React.FC<{
  overlayVisible: boolean;
  selectionEnabled: boolean;
  onToggleOverlay: () => void;
  onToggleSelection: () => void;
  onOpenConfigEditor?: () => void;
  isSelecting?: boolean;
}> = ({ overlayVisible, selectionEnabled, onToggleOverlay, onToggleSelection, onOpenConfigEditor, isSelecting = false }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        color: 'white',
        padding: '12px 16px',
        borderRadius: '8px',
        fontSize: '13px',
        zIndex: isSelecting ? 9000 : 10003, // Passe derrière pendant la sélection
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        transition: 'z-index 0.1s ease, opacity 0.2s ease',
        opacity: isSelecting ? 0.3 : 1 // Plus transparent pendant la sélection
      }}
    >
      <div style={{ fontWeight: 'bold', marginBottom: '4px', fontSize: '14px' }}>
        Contrôles Grille
      </div>
      
      <button
        onClick={onToggleOverlay}
        style={{
          padding: '8px 12px',
          backgroundColor: overlayVisible ? '#28a745' : '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: '500',
          transition: 'background-color 0.2s'
        }}
      >
        {overlayVisible ? '✓ Overlay visible' : '✗ Overlay caché'}
      </button>
      
      <button
        onClick={onToggleSelection}
        style={{
          padding: '8px 12px',
          backgroundColor: selectionEnabled ? '#28a745' : '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: '500',
          transition: 'background-color 0.2s'
        }}
      >
        {selectionEnabled ? '✓ Sélection activée' : '✗ Sélection désactivée'}
      </button>
      
      <button
        onClick={onOpenConfigEditor}
        style={{
          padding: '8px 12px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: '500',
          transition: 'background-color 0.2s'
        }}
      >
        ⚙️ Éditeur Config
      </button>
    </div>
  );
};

export default GridControls;
